// removed by extract-text-webpack-plugin
module.exports = {"container":"K3flxfFFemHIsX1Snf6uk","col-3":"bcvx3XA95BB-0DQtoZhSw","col":"_1hUQo7AMvlBy9_1ixRiEKL","row":"_1v1gZ2Z6VoqLhYvj19h1BA","col-md-6":"_37PYBbk5OUGqYJ2s_BNJ5p","col-lg-3":"_1yl9Swadm8N6R1xcYGd73S"};


//////////////////
// WEBPACK FOOTER
// ./components/elements/newsfeed/style.less
// module id = 60
// module chunks = 0